import React, { useState } from "react";
import styles from "./variantSelector.scss";
import { useSelector } from "react-redux";

import {
  getRouter,
  getProductStatus,
  renderDeliveryInfo,
  setNonStrictVariantsLS,
} from "../../../common/utils/helper";
import useVariantSelection from "@tw/shared-ui-components/lib/hooks/useVariantSelection";
import VariantDetails from "@tw/shared-ui-components/lib/components/variantDetails/variantDetails";
import VariantDrawerMobile from "@tw/shared-ui-components/lib/components/variantDrawerMobile/variantDrawerMobile";
import ProductActions from "@tw/shared-ui-components/lib/components/productActions/productActions";
import { updateCartDetails } from "@tw/header-footer/lib/redux/reducers";
import { getQueryUTMString } from '@tw/shared-ui-components/lib/utils/helper';

const VariantSelector = () => {
  const [open, setOpen] = useState(false);

  const variants = useSelector(
    (state) => state.pdpState && state.pdpState.variants
  );
  const skuList = useSelector(
    (state) => state.pdpState && state.pdpState.skuList
  );
  const validVariants = useSelector(
    (state) => state.pdpState && state.pdpState.validVariants
  );
  const productInfo = useSelector(
    (state) => state.pdpState && state.pdpState.info && state.pdpState.info
  );
  const productDetails = useSelector(
    (state) => state.pdpState && state.pdpState && state.pdpState
  );
  const router = getRouter();

  const onSelect = (selectedItemCode, nonStrictVariants) => {
    setNonStrictVariantsLS(nonStrictVariants);

    if (selectedItemCode && productInfo?.itemCode !== selectedItemCode) {
      router.push(`/products/${selectedItemCode}${getQueryUTMString("?")}`);
    }
  };

  const {
    selectedVariant,
    selectVariant,
    isValidVariant,
    isSelectedValue,
    getSelectedVariantValue,
  } = useVariantSelection(
    variants,
    skuList,
    validVariants,
    onSelect,
    productInfo?.itemCode
  );

  const closeButton = () => {
    setOpen(!open);
  };

  const renderVariants = () => (
    <>
      {variants &&
        variants.map((variant, variantIndex) => (
          <VariantDetails
            variant={variant}
            variantIndex={variantIndex}
            selectedVariant={selectedVariant}
            selectVariant={selectVariant}
            isValidVariant={isValidVariant}
            getSelectedVariantValue={getSelectedVariantValue}
            isSelectedValue={isSelectedValue}
            key={variantIndex}
          />
        ))}
    </>
  );

  // To handle notify me button click
  const onNotifyMeHandle = () => {
    setOpen(false);
  };

  const renderMobileDrawerFooter = () => (
    <div className={styles["cart-btns"]}>
      <ProductActions
        productInfo={productInfo}
        productStatusObj={getProductStatus(productInfo)}
        onSuccess={() => setOpen(false)}
        onNotifyMeHandle={onNotifyMeHandle}
        updateCartDetails={updateCartDetails}
      />
    </div>
  );

  const renderSelectedVariantDetail = (variant, variantIndex) => {
    const selectedValue = getSelectedVariantValue(variantIndex);
    const pipeElement = (selectedValue?.name || selectedValue?.value) &&
      variantIndex !== variants.length - 1 && (
        <span className={styles["selector-pipe"]}>|</span>
      );
    switch (variant.code) {
      case "multi_dimension_color":
        return (
          <>
            <div className={styles["selector-color-values"]} key={variantIndex}>
              <p>{selectedValue?.value}</p>
              <div
                className={styles["shade_btn"]}
                style={{
                  backgroundImage: `url(${selectedValue?.image})`,
                }}
              ></div>
            </div>
            {pipeElement}
          </>
        );

      default:
        return (
          <>
            <div className={styles["selector-default"]} key={variantIndex}>
              {selectedValue?.name || selectedValue?.value}
            </div>
            {pipeElement}
          </>
        );
    }
  };

  return (
    <div className={styles["product_variants"]}>
      {!(variants && variants.length > 0) ? null : (
        <>
          <div className={styles["selector-main"]} onClick={closeButton}>
            <div className={styles["selector-wrapper"]}>
              <div className={styles["selector-cont"]}>
                <div className={styles["selected-details"]}>
                  <p className={styles["selected-text"]}>已選:</p>

                  <div className={styles["selected-options"]}>
                    {variants &&
                      variants.length &&
                      variants.map((variant, variantIndex) => (
                        <>
                          {renderSelectedVariantDetail(variant, variantIndex)}
                        </>
                      ))}
                  </div>
                </div>
              </div>

              <div className={styles["selector-option"]}>
                <a className={styles["selector-link"]}>
                  <svg
                    width="8"
                    height="18"
                    viewBox="0 0 4 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="2" cy="2" r="2" fill="#2C2C2C" />
                    <circle cx="2" cy="9" r="2" fill="#2C2C2C" />
                    <circle cx="2" cy="16" r="2" fill="#2C2C2C" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </>
      )}
      <VariantDrawerMobile
        open={open}
        setOpen={setOpen}
        productInfo={productInfo}
        renderVariants={renderVariants}
        renderFooter={renderMobileDrawerFooter}
        renderAdditionalInfo={productInfo?.isSOP && renderDeliveryInfo(productDetails)}
        productStatus={getProductStatus(productInfo)}
        variantSelector={true}
      />

      {!(variants && variants.length > 0) ? null : (
        <div className={styles["desktop_variant"]}>{renderVariants()}</div>
      )}
    </div>
  );
};

export { VariantSelector };
